import * as React from "react";

import {ProductCarousel} from "./product-carousel/product-carousel";
import "./branded-product.scss";

export const BrandedProduct = ({themeScheme}) => {
    const products = configCompany(themeScheme)
    if(!products) {
        return null
    }

    return (
        <div className="products-br2">
            <div className="products-header">
                <h3
                    style={{
                        color: themeScheme?.xpresso?.menuBackgroundColor
                    }}
                    xd-qa-type="label"
                    xd-qa-name="Products Title"
                >   
                    Marketing Made Simple
                </h3>
                <p xd-qa-type="text" xd-qa-name="Products Message">
                    {messageMarketing}
                </p>
            </div>
            <ProductCarousel themeScheme={themeScheme} products={products} />
        </div>
    )
}

const messageMarketing = `Experience unmatched agency-quality designs that can be produced within a matter of minutes`

export const ID_COMPANY_KELLAR_WILLIAMS = '18KELLERWILLIAMSDF47'
const ID_REAL_LIVING = 'beb2bd5d'
const ID_BERKSHIRE_HATHAWAY = 'de0cbb1542'
const ID_REMAX_INTERNATIONAL = '40RMXNATIONAL'
const ID_LEADING_REAL_ESTATE = '150LUXURYP'
const ID_CENTURY_21 = '129CENTURY'
const ID_FLORIDA_ASSOCIATION_REALTORS = 'e408b892'
const ID_COLDWELL_BANKER = '130COLDWEL'

const configCompany = (themeScheme) => {
    switch(themeScheme?.schemeLevelId) {
        case ID_COMPANY_KELLAR_WILLIAMS:
            return configKellerWilliams
        case ID_REAL_LIVING:
            return configRealLiving
        case ID_BERKSHIRE_HATHAWAY:
            return configBerkshireHathaway
        case ID_REMAX_INTERNATIONAL:
            return configRemaxInternational
        case ID_LEADING_REAL_ESTATE:
            return configLeadingRealEstate
        case ID_CENTURY_21:
            return configCentury21
        case ID_FLORIDA_ASSOCIATION_REALTORS:
            return configFloridaAssociation
        case ID_COLDWELL_BANKER:
            return configColdwellBanker
        default:
            return null
    }
}

const carousel = (header, text, source) => {
    return {
        'header': header,
        'text': text,
        'source': source
    }
}

const configKellerWilliams = [
    carousel('Postcards', 'Order Postcards', '/next_images/landing_page/18KELLERWILLIAMSDF47/18161.jpg'),
    carousel('Brochures & Flyers', 'See Our New Designs', '/next_images/landing_page/18KELLERWILLIAMSDF47/18278.jpg'),
    carousel('Seasonal', 'Show some love',  '/next_images/landing_page/de0cbb1542/Seasonal%20Templates.jpg'),
    carousel('Wallet Brochures', 'Pocket-Sized Marketing', '/next_images/landing_page/18KELLERWILLIAMSDF47/18158.jpg'),
    carousel('Prospecting & Farming', 'Gain New Leads', '/next_images/landing_page/18KELLERWILLIAMSDF47/18127.jpg'),
    carousel('Brand Essentials', 'Make an Impression', '/next_images/landing_page/18KELLERWILLIAMSDF47/stationary.jpg')
]

const configRealLiving = [
    carousel('Postcards', 'Order Postcards', '/images/xd/cobrand/rlre/postcard-preview.png'),
    carousel('Brochures & Flyers', 'See Our New Designs', '/images/xd/cobrand/rlre/brochure-and-flyer-preview.png'),
    carousel('Seasonal', 'Show some love',  '/next_images/landing_page/de0cbb1542/Seasonal%20Templates.jpg'),
    carousel('Wallet Brochures', 'Pocket-Sized Marketing', '/images/xd/cobrand/rlre/wallet-brochure.png'),
    carousel('Prospecting & Farming', 'Gain New Leads', '/images/xd/cobrand/rlre/prospect-farming.png'),
    carousel('Brand Essentials', 'Make an Impression', '/images/xd/cobrand/rlre/brand-essentials.png')
]

const configRemaxInternational = [
    carousel('Postcards', 'Order Postcards', '/images/xd/cobrand/remax/postcard-preview.png'),
    carousel('Brochures & Flyers', 'See Our New Designs', '/images/xd/cobrand/remax/brochure-and-flyer-preview.png'),
    carousel('Seasonal', 'Show some love', '/next_images/landing_page/de0cbb1542/Seasonal%20Templates.jpg'),
    carousel('Wallet Brochures', 'Pocket-Sized Marketing', '/images/xd/cobrand/remax/wallet-brochure.png'),
    carousel('Prospecting & Farming', 'Gain New Leads', '/images/xd/cobrand/remax/prospect-farming.png'),
    carousel('Brand Essentials', 'Make an Impression', '/images/xd/cobrand/remax/brand-essentials.png')
]

const configLeadingRealEstate = [
    carousel('Postcards', 'Order Postcards', '/next_images/landing_page/150LUXURYP/66898.jpg'),
    carousel('Brochures & Flyers', 'See Our New Designs', '/next_images/landing_page/150LUXURYP/61932.jpg'),
    carousel('Seasonal', 'Show some love', '/next_images/landing_page/de0cbb1542/Seasonal%20Templates.jpg'),
    carousel('Wall Calendars', 'Personalized', '/next_images/landing_page/150LUXURYP/11790.jpg'),
    carousel('Personal Marketing', 'Newsletters and More', '/next_images/landing_page/150LUXURYP/Personal%20Marketing.jpg'),
    carousel('Brand Essentials', 'Make an Impression', '/next_images/landing_page/150LUXURYP/11837.jpg')
]

const configCentury21 = [
    carousel('Postcards', 'Order Postcards', '/next_images/landing_page/129CENTURY/6829.jpg'),
    carousel('Brochures & Flyers', 'See Our New Designs', '/next_images/landing_page/129CENTURY/6879.jpg'),
    carousel('Seasonal', 'Show some love', '/next_images/landing_page/de0cbb1542/Seasonal%20Templates.jpg'),
    carousel('Wallet Brochures', 'Pocket-Sized Marketing', '/next_images/landing_page/129CENTURY/6646.jpg'),
    carousel('Personal Marketing', 'Newsletters and More', '/next_images/landing_page/129CENTURY/Personal%20Marketing.jpg'),
    carousel('Brand Essentials', 'Make an Impression', '/next_images/landing_page/129CENTURY/stationary.jpg')
]

const configFloridaAssociation = [
    carousel('Postcards', 'Order Postcards', '/next_images/landing_page/e408b892/68645.jpg'),
    carousel('Brochures & Flyers', 'See Our New Designs ', '/next_images/landing_page/e408b892/68688.jpg'),
    carousel('Seasonal', 'Show some love', '/next_images/landing_page/de0cbb1542/Seasonal%20Templates.jpg'),
    carousel('Marketing Tools', 'Invites and Announcements', '/next_images/landing_page/e408b892/68983.jpg'),
    carousel('Prospecting & Farming', 'Gain New Leads', '/next_images/landing_page/e408b892/68960.jpg'),
    carousel('Upload Your Own', 'Use your own designs', '/next_images/landing_page/e408b892/68565.jpg')
]

const configColdwellBanker = [
    carousel('Postcards', 'Order Postcards', '/next_images/landing_page/130COLDWEL/8091.jpg'),
    carousel('Brochures & Flyers', 'See Our New Designs ', '/next_images/landing_page/130COLDWEL/8176.jpg'),
    carousel('Seasonal', 'Show some love', '/next_images/landing_page/de0cbb1542/Seasonal%20Templates.jpg'),
    carousel('Wallet Brochures', 'Pocket-Sized Marketing', '/next_images/landing_page/130COLDWEL/8016.jpg'),
    carousel('Prospecting & Farming', 'Gain New Leads', '/next_images/landing_page/130COLDWEL/60788.jpg'),
    carousel('Upload Your Own', 'Use your own designs', '/next_images/landing_page/130COLDWEL/61535.jpg')
]

const configBerkshireHathaway = [
    carousel('Postcards', 'Order Postcards', '/next_images/landing_page/de0cbb1542/45697.jpg'),
    carousel('Brochures & Flyers', 'See Our New Designs', '/next_images/landing_page/de0cbb1542/45730.jpg'),
    carousel('Seasonal', 'Show some love', '/next_images/landing_page/de0cbb1542/Seasonal%20Templates.jpg'),
    carousel('Wallet Brochures', 'Pocket-Sized Marketing', '/next_images/landing_page/de0cbb1542/45727.jpg'),
    carousel('Prospecting & Farming', 'Gain New Leads', '/next_images/landing_page/de0cbb1542/45685.jpg'),
    carousel('Brand Essentials', 'Make an Impression', '/next_images/landing_page/de0cbb1542/stationary.jpg')
]

